var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"card search-view-cardsearch"},[_c('router-link',{attrs:{"to":{
      name: 'course',
      params: {
        ..._vm.results
      }
    }}},[_c('img',{staticClass:"card-img-top img-fluid",attrs:{"src":_vm.results.cover,"alt":_vm.results.title}}),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title mt-2 text-center"},[_vm._v(_vm._s(_vm.results.title))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }